


/* eslint-disable no-sequences */
/* eslint-disable no-unused-vars */
/* eslint-disable no-param-reassign */
/* eslint-disable no-unused-expressions */

import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { defaultReject, defaultState } from "../../../../constants";
import { fetchData } from "../../../../helpers";

// REJECTABOUTUSSECTION
// REJECTABOUTUSSECTION


const REJECTABOUTUSSECTION= createAsyncThunk(
  "rejectAboutUsSection/rejectAboutUsSection",
  // eslint-disable-next-line default-param-last
  async (
    // eslint-disable-next-line default-param-last
    payload = {},
    { rejectWithValue }
  ) => {
    try {
      const data = await fetchData(
        payload?.data,
        payload?.method,
        payload?.apiName
      );
      return {
        ...defaultState.List,
        message: data?.data.Message,
        data: data?.data?.data,
      };
    } catch (error) {
      return rejectWithValue({
        ...defaultReject.List,
        message: error.message,
      });
    }
  }
);

// PublishPostSlice
const rejectAboutUsSectionSlice = createSlice({
  name: "rejectAboutUsSectionSlice",
  initialState: {
    rejectAboutUsSection: {
      ...defaultState.List,
      loading: false, 
      error: false, 
    },
  },
  reducers: {
    setInitialStateOfrejectAboutUsSection: (state) => {
        state.rejectAboutUsSection.loading = false
        state.rejectAboutUsSection.error = false
        state.rejectAboutUsSection.data = []
        state.rejectAboutUsSection.message = ''
      }
  },
  extraReducers: (builder) => {
    builder.addCase(REJECTABOUTUSSECTION.fulfilled, (state, action) => {
      state.rejectAboutUsSection = {
        ...state.rejectAboutUsSection,
        loading: false,
        error: false,
        ...action.payload,
      };
    });
    builder.addCase(REJECTABOUTUSSECTION.pending, (state, action) => {
      state.rejectAboutUsSection = {
        ...state.rejectAboutUsSection,
        loading: true,
        error: false,
        ...action.payload,
      };
    });
    builder.addCase(REJECTABOUTUSSECTION.rejected, (state, action) => {
      state.rejectAboutUsSection = {
        ...state.rejectAboutUsSection,
        loading: false,
        error: true,
        ...action.payload,
      };
    });
  },
});

const rejectAboutUsSectionAction = {
    REJECTABOUTUSSECTION,
};

export { rejectAboutUsSectionAction };
export default rejectAboutUsSectionSlice.reducer;
export const {setInitialStateOfrejectAboutUsSection} = rejectAboutUsSectionSlice.actions
